/**
 * The small uppercase chip that says what state a note or a token is in.
 *
 * The note words are the design's, and one of them is a sentence rather than a label for a reason:
 * "Edited since publishing" is the state where an agent is still being served the *older* text, and
 * "Edited" alone does not say that. The cost of a wider chip is worth it.
 */

import type { NoteState, TokenState } from "../lib/api/types";

const NOTE_WORDS: Record<NoteState, string> = {
  draft: "Draft",
  published: "Published",
  edited: "Edited since publishing",
  flagged: "Flagged · unreviewed",
};

const TOKEN_WORDS: Record<TokenState, string> = {
  active: "Active",
  "never-used": "Never used",
  revoked: "Revoked",
};

export function NoteStateChip({ state }: { state: NoteState }) {
  return (
    <span className="chip" data-state={state}>
      {NOTE_WORDS[state]}
    </span>
  );
}

export function TokenStateChip({ state }: { state: TokenState }) {
  // Reuses the note palette deliberately: a revoked token and a draft note are both "inert", a
  // live token and a published note are both "in force". Two palettes for one vocabulary is how a
  // green starts meaning different things on different screens.
  const tone = state === "active" ? "published" : state === "never-used" ? "edited" : "draft";
  return (
    <span className="chip" data-state={tone}>
      {TOKEN_WORDS[state]}
    </span>
  );
}
